/** The app download page's one segment — `/{locale}/app/`. */
export const APP_PAGE_SEGMENT = 'app'
